import { render, staticRenderFns } from "./CenterViewEventTicketIssueDetail_Ap.vue?vue&type=template&id=2c7db313&scoped=true"
import script from "./CenterViewEventTicketIssueDetail_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventTicketIssueDetail_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventTicketIssueDetail_Ap.vue?vue&type=style&index=0&id=2c7db313&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7db313",
  null
  
)

export default component.exports